import { render } from "./VIcon.vue?vue&type=template&id=7c7eccb2"
import script from "./VIcon.vue?vue&type=script&lang=js"
export * from "./VIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__